import type { Detail } from "../types"
import SitesTable from "./SitesTable"

// Stock per warehouse, so the room can see stock stuck where nothing moves
// and decide to move it rather than promote it. Incoming orders and the
// new-product note sit above, under the product name (StockNotes).
export default function WhereItSits({ detail }: { detail: Detail }) {
  return (
    <div className="overflow-hidden rounded-md border">
      <SitesTable sites={detail.sites} />
    </div>
  )
}
